import React from 'react'
import Play80Icon from '../../../assets/codicons/play-80'

const VideoCard = ({ video }) => {
  return (
    <div className='video-card' data-video-id={video.id}>
      <div
        className='video-card-inner'
        style={{
          backgroundImage: `url(${video.thumbnail?.url || video.thumbnail})`
        }}
      >
        <div className='selected-overlay' />
        <div className='play-icon-container'>
          <Play80Icon />
        </div>
      </div>
    </div>
  )
}

export default VideoCard
